import { atom } from "recoil";

export const imagesState = atom({
  key: "imagesState",
  default: [],
});
